import { AdaptAvailableTasksThemeReadIntoMenuType, Menu } from "./types";

export const groupIsActive = (group: Menu, expanded: number[] | undefined) =>
  expanded && group.sub_groups.some(sub_group => sub_group.questions.some(({ id }) => expanded?.includes(id)));

export const adaptAvailableProtocolQuestionsSubThemeReadIntoMenu: AdaptAvailableTasksThemeReadIntoMenuType =
  originalData =>
    originalData.map(theme => ({
      group_id: theme.theme_id,
      group_name: theme.theme_name,
      sub_groups: theme.sub_themes.map(sub_theme => ({
        sub_group_id: sub_theme.sub_theme_id,
        sub_group_name: sub_theme.sub_theme_name,
        questions: [...sub_theme.questions],
      })),
    }));
